



































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ApiService } from '@/api/api.service'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import { getBoUrl } from '@/api/http-constants'

interface IRoom {
    room: number
    size: string | null
    quantity: number
    options: Array<string>
}

@Component({
    components: {
        SmoothReflow,
    },
})
export default class Pieces extends Vue {
    @Prop({
        default: [],
    })
    rooms!: Array<IRoom>
    @Prop({
        default: 0,
    })
    surfaceSouhaitee!: number

    apiService = new ApiService()
    boUrl = getBoUrl()
    roomsDefinition = null
    loaded = false
    settings = {
        copyClassesToDropdown: false,
        plugins: {
            remove_button: {
                title: 'Enlever',
                label: '<i class="fa fa-times-circle"></i>',
                className: 'selectize-remove-button',
            },
        },
        /**
         * On s'assure que la classe active est bien supprimée lors de l'ajout
         * d'un item.
         */
        onItemAdd: function(value, $item) {
            const item = $item.get()[0]
            item.classList.remove('active')

            // Pour compenser closeAfterSelect qui ne marche pas
            this.$control[0].querySelector('input').blur()
        },
        /**
         * Fix la non suppression du hightlight
         */
        onType: function(str) {
            if (str === '') {
                this.$dropdown_content.removeHighlight()
            }
        },
        onFocus: function(str) {
            requestAnimationFrame(() => {
                this.$dropdown_content.removeHighlight()
            })
        },
    }
    smoothReflowSettings = {
        transitionEvent: {
            selector: 'div',
            propertyName: 'opacity',
        },
    }

    sizes = {
        xs: 'Mini',
        s: 'Petit',
        m: 'Intermédiaire',
        l: 'Grand',
        xl: 'Très grand',
    }

    pRooms: IRoom[] = this.rooms
    @Watch('rooms')
    updateRooms(val) {
        this.pRooms = val
        this.loaded = true
        requestAnimationFrame(() => {
            const $popover = $('.popover-dismiss') as any
            $popover.popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }

    selectedRoom: IRoom = null
    currentRoom: IRoom = {
        room: null,
        size: null,
        quantity: 0,
        options: [],
    }

    surfaceTotale: number = 0

    @Watch('pRooms', { deep: true })
    @Watch('roomsDefinition', { deep: true })
    onRooms() {
        var total = 0
        for (const key in this.pRooms) {
            const room = this.pRooms[key]
            const size = this.roomsDefinition[room.room][room.size]
            if (size) {
                total += size * room.quantity
            }
        }

        this.surfaceTotale = total
        this.$emit('surfaceTotale', total)
    }

    surfaceErrorMessage = ''
    isSurfaceOk: boolean = false

    @Watch('surfaceSouhaitee')
    @Watch('surfaceTotale')
    onSurface() {
        const surfaceOk =
            this.surfaceSouhaitee + 8 > this.surfaceTotale &&
            this.surfaceTotale > this.surfaceSouhaitee - 8

        if (this.surfaceTotale >= this.surfaceSouhaitee + 8) {
            this.surfaceErrorMessage =
                'La surface configurée est nettement supérieure à la surface souhaitée.'
        } else if (this.surfaceTotale <= this.surfaceSouhaitee - 8) {
            this.surfaceErrorMessage =
                'La surface configurée est nettement inférieure à la surface souhaitée.'
        } else {
            this.surfaceErrorMessage = ''
        }
        this.isSurfaceOk = surfaceOk
        this.$emit('isSurfaceOk', surfaceOk)
    }

    created() {
        this.apiService.getRooms().then(response => {
            // Amélioration des définitions de room
            var roomsDefinition = {}
            response.data.forEach(val => {
                // ajout d'un tableaux sizes regroupant les tailles
                var sizes = []
                for (var key in val) {
                    if (key in this.sizes && val[key] !== null) {
                        sizes.push(key)
                    }
                }
                val = {
                    ...val,
                    sizes,
                }
                // ajout de la room aux definitions
                roomsDefinition[val.id] = val
            })
            this.roomsDefinition = roomsDefinition
        })
    }

    showAddModal() {
        ;(<any>$(this.$refs.addModal)).modal({
            backdrop: 'static',
        })
    }

    showEditModal() {
        ;(<any>$(this.$refs.editModal)).modal({
            backdrop: 'static',
        })
    }

    addRoom(e) {
        e.preventDefault()

        const room: IRoom = {
            room: this.currentRoom.room,
            size: this.currentRoom.size,
            options: this.currentRoom.options,
            quantity: 1,
        }
        this.pRooms.push(room)
        this.cleanUp()
        ;(<any>$(this.$refs.addModal)).modal('hide')

        this.$emit('rooms', this.pRooms)
    }

    selectRoom(room: IRoom) {
        this.selectedRoom = room
        this.currentRoom.room = room.room
        this.currentRoom.size = room.size
        this.currentRoom.options = room.options
    }

    saveRoom(e) {
        e.preventDefault()

        this.selectedRoom.room = this.currentRoom.room
        this.selectedRoom.size = this.currentRoom.size
        this.selectedRoom.options = this.currentRoom.options
        ;(<any>$(this.$refs.editModal)).modal('hide')

        this.$emit('rooms', this.pRooms)
    }

    deleteRoom(room) {
        const index = this.pRooms.indexOf(room)
        this.pRooms.splice(index, 1)
    }

    moreQuantity(room) {
        room.quantity++
    }

    lessQuantity(room) {
        if (room.quantity === 1) {
            return
        }
        room.quantity--
    }

    cleanUp(): any {
        this.currentRoom.room = null
        this.currentRoom.size = null
        this.currentRoom.options = null
        this.selectedRoom = null
    }

    mounted() {
        ;(<any>$(this.$refs.addModal)).on('hidden.bs.modal', this.cleanUp)
        ;(<any>$(this.$refs.editModal)).on('hidden.bs.modal', this.cleanUp)

        requestAnimationFrame(() => {
            ;(<any>$('.popover-dismiss')).popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }
    destroyed() {
        ;(<any>$(this.$refs.addModal)).off('hidden.bs.modal', this.cleanUp)
        ;(<any>$(this.$refs.editModal)).off('hidden.bs.modal', this.cleanUp)
    }

    @Watch('currentRoom.room')
    onCurrentRoomChange() {
        // Reinitialize popovers when room type changes
        this.$nextTick(() => {
            ;(<any>$('.popover-dismiss')).popover('dispose')
            ;(<any>$('.popover-dismiss')).popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }

    /**
     * Utile pour le transition-group
     */
    lastUids = new Map()
    get uids() {
        let uids = new Map()
        for (const key in this.pRooms) {
            const room = this.pRooms[key]
            var uid = this.lastUids.get(room)
            if (!uid) {
                uid = this.guid()
            }
            uids.set(room, uid)
        }
        this.lastUids = uids
        return uids
    }

    uid(room: IRoom) {
        return this.uids.get(room)
    }

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1)
        }
        return (
            s4() +
            s4() +
            '-' +
            s4() +
            '-' +
            s4() +
            '-' +
            s4() +
            '-' +
            s4() +
            s4() +
            s4()
        )
    }

    getRoomGuide(roomId: number): string | null {
        if (!this.roomsDefinition || !this.roomsDefinition[roomId]) return null
        const name = this.roomsDefinition[roomId].name.toLowerCase()

        if (name.includes('chambre')) {
            return "La taille standard d'une chambre est comprise entre 9 et 12 m2"
        }
        if (name.includes('cuisine') || name.includes('salon') || name.includes('salle à manger') || name.includes('séjour') || name.includes('pièce de vie')) {
            return "Un appartement neuf est généralement composé d'une pièce de vie ouverte comprenant l'espace cuisine, salon et salle à manger dont la taille standard est comprise entre 20 et 30 m2. À vous de réinventer ces pièces à votre image !"
        }
        if (name.includes('salle de bain') || name.includes('sdb') || name.includes('salle de bains')) {
            return "La taille standard d'une salle de bain est comprise entre 3 et 5 m2"
        }
        if (name.includes('toilettes') || name.includes('wc')) {
            return "La taille standard des toilettes est de 2 m2"
        }
        if (name.includes('entrée')) {
            return "La taille standard d'une entrée est comprise entre 2 et 5 m2"
        }

        return null
    }
}
